import Component from "flarum/Component";
import Button from 'flarum/components/Button';
import DecorationStorePurchaseSubscriptionModal from './DecorationStorePurchaseSubscriptionModal';
import itemActualCost from "../common/util/itemActualCost";

export default class DecorationStorePurchaseListItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }

  view() {
    const {itemPurchaseData} = this.attrs;
    const moneyName = app.forum.attribute('antoinefr-money.moneyname') || '[money]';

    this.purchaseID = itemPurchaseData.id();
    const itemData = itemPurchaseData.decorationData();
    const itemTitle = itemData.item_title();
    const itemType = itemData.item_type();
    const itemTypeText = app.translator.trans("ziven-decoration-store.forum.item-purchase-item-type-"+itemType);
    const itemPurchaseCount = itemPurchaseData.item_count();
    const itemPurchaseActualCost = itemActualCost(itemPurchaseData,itemPurchaseCount);
    const itemPurchaseCostText = moneyName.replace('[money]', itemPurchaseActualCost);
    const itemPurchaseType = itemPurchaseData.purchase_type();
    const itemPurchaseDate = itemPurchaseData.assigned_at();
    const itemPurchaseTypeText = app.translator.trans("ziven-decoration-store.lib.item-purchase-type-"+itemPurchaseType);
    const itemProperty = JSON.parse(itemData.item_property());
    const itemPropertyImage = itemProperty.image;

    const itemStatus = itemPurchaseData.item_status();
    const itemExpired = itemPurchaseData.is_expired();
    const itemExpireDays = itemPurchaseData.expired_days();
    let itemStatusText = app.translator.trans("ziven-decoration-store.forum.item-purchase-item-status-"+itemStatus);
    let itemStatusStyle = "";

    if(itemExpired===1){
        itemStatusText = app.translator.trans("ziven-decoration-store.forum.item-expired");
        itemStatusStyle = "color:red";
    }else{
      if(itemStatus===0){
        itemStatusStyle = "color:gray";
      }else if(itemStatus===1){
        itemStatusStyle = "color:green";
      }
      
      if(itemPurchaseType!=="onetime"){
        itemStatusText = app.translator.trans("ziven-decoration-store.forum.item-purchase-subscribe-item-status-"+itemStatus);
      }
    }

    let itemImageStyle = "";
    if(itemType==="profileBackground"){
      itemImageStyle = "background-image:url("+itemPropertyImage+")";
    }

    return (
      <div className="DecorationPurchaseListItemContainer">
        <div>
          {itemType==="avatarFrame" && (
            <img className="DecorationPurchaseItemAvatarImage" src={itemPropertyImage} />
          )}
          {itemType==="profileBackground" && (
            <div className="DecorationPurchaseItemProfileBackgroundImage" style={itemImageStyle}></div>
          )}
          {itemType==="usernameColor" && (
            <div className="DecorationPurchaseItemUsernameColor">
              <div className={itemPropertyImage}>{app.translator.trans("ziven-decoration-store.forum.item-property-style-text-effect")}</div>
            </div>
          )}
          
          <b>{app.translator.trans('ziven-decoration-store.forum.item-purchase-title')}: </b>
          {itemTitle}
          <br />

          <b>{app.translator.trans('ziven-decoration-store.forum.item-purchase-purchase-type')}: </b>
          {itemPurchaseTypeText}&nbsp;|&nbsp;

          <b>{app.translator.trans('ziven-decoration-store.forum.item-purchase-date')}: </b>
          {itemPurchaseDate}
          <br />

          <b>{app.translator.trans('ziven-decoration-store.forum.item-purchase-item-status')}: </b>
          <span style={itemStatusStyle}>{itemStatusText}</span>&nbsp;|&nbsp;

          {itemPurchaseType==="onetime" && (
            <span>
              <b>{app.translator.trans('ziven-decoration-store.forum.item-purchase-cost')}: </b>
              {itemPurchaseCostText}
            </span>
          )}

          {itemPurchaseType!=="onetime" && (
            <span>
              <b>{app.translator.trans('ziven-decoration-store.forum.item-purchase-subscription-cost')}: </b>
              {itemPurchaseCostText} ({app.translator.trans('ziven-decoration-store.forum.item-subscription-deduction-days',{days:itemExpireDays})})
            </span>
          )}

        </div>

        {itemPurchaseType!=="onetime" && itemExpired===0 && (
          <div className="DecorationPurchaseListSubscribeButtonContainer">
            {Button.component({
                style: "color:white",
                className: 'Button decorationButton--red',
                onclick: (e) => {
                  this.showSubscribeStatusModal(itemPurchaseData,1)
                }
              },
            app.translator.trans('ziven-decoration-store.forum.item-unsubscribe')
            )}
          </div>
        )}

        {itemPurchaseType!=="onetime" && itemExpired===1 && (
          <div className="DecorationPurchaseListSubscribeButtonContainer">
            {Button.component({
                style: "color:white",
                className: 'Button Button--primary',
                onclick: (e) => {
                  this.showSubscribeStatusModal(itemPurchaseData,0)
                }
              },
            app.translator.trans('ziven-decoration-store.forum.item-subscribe')
            )}
          </div>
        )}
      </div>
    );
  }

  showSubscribeStatusModal(itemPurchaseData,purchaseExpired){
    app.modal.show(DecorationStorePurchaseSubscriptionModal, {itemPurchaseData,purchaseExpired});
  }

}
